import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
function InputDISC(props) {
    return (
            <Row className='justify-content-center py-3' xxl={7} xl={5} lg={4} md={1}>
                <Col>
                    <ToggleButtonGroup type="radio" name={props.name} value={props.value} onChange={props.handleChange}>
                        <ToggleButton id={`${props.name}1`} variant='outline-danger' value={1} style={{ width: '120px' }}>
                            Dominant
                        </ToggleButton>
                        <ToggleButton id={`${props.name}2`} variant='outline-warning' value={2} style={{ width: '120px' }}>
                            Influential
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
                
                <Col>
                    <ToggleButtonGroup type="radio" name={props.name} value={props.value} onChange={props.handleChange}>
                        <ToggleButton id={`${props.name}3`} variant='outline-success' value={3} style={{ width: '120px' }}>
                            Steady
                        </ToggleButton>
                        <ToggleButton id={`${props.name}4`} variant='outline-primary' value={4} style={{ width: '120px' }}>
                            Compliant
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
            </Row>
    );
}

export default InputDISC
